import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useDebouncedCallback } from 'use-debounce';
import { SectionDetailLabel } from '../styles';
import Loading from '../../../../../shared/loading';

const Label = styled(SectionDetailLabel)`
  & > input {
    height: 40px !important;
    border-radius: 3px !important;
    border: 1px solid #D7DFE7 !important;
    padding-left: 16px !important;
    font-size: 17px !important;
  }
`;

const FeedbackContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const ErrorMessage = styled.span`
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  font-size: 13px;
  color: ${props => props.theme.errorColor};
`;

export default function InputText({
  initialValue, onChange, placeholder, label, isLoading, error,
}) {
  const [value, setValue] = React.useState(initialValue || '');
  const [errorMessage, setErrorMessage] = React.useState(null);
  const loadingRef = React.useRef();
  const { callback: debounceUpdate } = useDebouncedCallback(onChange, 300);

  React.useEffect(() => (loadingRef.current[isLoading ? 'start' : 'stop']()));

  React.useEffect(() => {
    const message = error ? `Please enter a valid ${label} profile url.` : null;
    setErrorMessage(message);
  }, [error, label]);

  const handleChange = e => {
    const newValue = e.target.value;
    setValue(newValue);
    debounceUpdate(newValue);
  };

  return (
    <>
      <Label>
        {label}
        <input
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
        />
      </Label>
      <FeedbackContainer>
        <ErrorMessage>{errorMessage}</ErrorMessage>
        <Loading variant="sip" ref={loadingRef} />
      </FeedbackContainer>
    </>
  );
}

InputText.propTypes = {
  initialValue: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.shape(),
};

InputText.defaultProps = {
  initialValue: null,
  placeholder: null,
  error: null,
};
